import FormDatePicker from '@/app/components/DatePicker/FormDatePicker';
import AddressFormPart from '@/app/components/DonationForm/donationFormParts/AddressFormPart';
import FormInput from '@/app/components/Input/FormInput';
import { SelectOption } from '@/app/components/Select/Select';
import { Country } from '@/app/enums';
import { countryConfig } from '@/app/utils/countryConfig';
import { useTranslation } from 'react-i18next';

type DonationReceiptInfoInputsProps = {
  displayPhoneNumber: boolean;
  displayBirthDate: boolean;
  displayCountrySelect: boolean;
  countries: SelectOption<Country>[];
  displayTinNote?: boolean;
  isCompanyNameRequired?: boolean;
};

export const DonationReceiptInfoInputs = ({
  displayPhoneNumber,
  displayBirthDate,
  displayCountrySelect,
  countries,
  displayTinNote,
  isCompanyNameRequired,
}: DonationReceiptInfoInputsProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <FormInput
        name="nameOnReceipt"
        label={
          isCompanyNameRequired
            ? t('components.DonationForm.companyNameOrBusinessName')
            : t('components.DonationForm.nameOnReceipt')
        }
      />

      {displayPhoneNumber && (
        <FormInput
          name="phoneNumber"
          label={t('components.DonationForm.phoneNumberLabel')}
          placeholder={countryConfig.donationFormCommon.phoneNumberFieldPlaceholder}
        />
      )}

      <AddressFormPart countrySelectOptions={countries} shouldDisplayCountrySelect={displayCountrySelect} />
      <FormInput
        name="tin"
        label={t('components.DonationForm.tin')}
        note={displayTinNote ? t('components.DonationForm.tinNote') : undefined}
      />
      {displayBirthDate && <FormDatePicker name="birthDate" label={t('components.DonationForm.birthDate')} />}
    </div>
  );
};
